import { useEffect, useRef, useState } from 'react';
import { useParams } from "react-router-dom";
import { RichiestaService } from "../../../services/RichiestaService";
import Step6 from './Step6/Step6';
import { NazioneService } from '../../../services/NazioneService';
import { tipologieFase } from '../../../constants/TipologiaFase';
import Step6Ripresentazione from './Step6Ripresentazione/Step6Ripresentazione';

const DettaglioRichiesta = () => {    
  const {id} = useParams();
  const [richiesta, setRichiesta] = useState(null);

  const [nations, setNations] = useState(null);

  const scrollRef = useRef(null);

  const nazioneService = new NazioneService();
  const richiestaService = new RichiestaService();

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, [richiesta]);

  
  
  const getRichiesta = async() => {
    if (!id) return;
    const resp = await richiestaService.get(id);
    setRichiesta(resp);    
  }

  

  useEffect(() => {
    getRichiesta();
    nazioneService.getAll().then(resp => {
      let nations = [...resp];
      const italia = nations.find((nazione) => nazione.nome === "Italia");
      nations.sort((a, b) => a.cittadinanza.localeCompare(b.cittadinanza));
      nations = nations.filter((nazione) => nazione.nome !== "Italia");
      nations.unshift(italia);
      setNations(nations);
    });
  }, []);

  const renderStep = (index) => {
    if (!richiesta) return;
    
    switch (index) {
    
      case 5:
        return richiesta.fase.tipologia === tipologieFase.riapertura_presentazione || richiesta.bando.instructions==='4I'
                  ? <Step6Ripresentazione
                      richiesta={richiesta}
                      nazioni={nations}
                      readonly={true}
                    />
                  : <Step6
                      richiesta={richiesta}
                      nazioni={nations}
                      readonly={true}
                    />;
      default:
        return <>          
        </>;
    }
  }

  return (
    <>
      <section className="rtds-grid rtds-gap-4" hidden={richiesta}>
        <div
          className="rtds-empty-state rtds-grid rtds-gap-4"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
            <svg
              className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-animate-spin"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use 
               xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
              />
            </svg>
            <span className="rtds-sr-only">Caricamento...</span>

            <h3 className="rtds-heading-4">
              <div className="loading-message">
                Attendere un momento
                <span className="dots">...</span>
              </div>
            </h3>
          </div>
        </div>
      </section>

      <div
        className="rtds-container rtds-my-12"
        hidden={!richiesta}
        ref={scrollRef}
      >
        {richiesta && (
          <div
            key={5}
            hidden={false}
            id={`tabpanel-5`}
            className="rtds-tablist__tabpanel"
            role="tabpanel"
            aria-labelledby={`tab-5`}
          >
            {renderStep(5)}
          </div>
        )}        
      </div>
    </>
  );
};

export default DettaglioRichiesta;
